module.exports = __webpack_public_path__ + "img/industriaycomercio.9cbc3e63.svg";